<template>
    <div class="modify-password">
        <div class="modify-password-left">
            <!-- 分为已实名认证和未实名认证 -->
            <el-row>
                <el-col :md="24">
                    <el-form ref="form" :model="model" label-width="100px">
                        <template>
                            <el-form-item label="原密码：" prop="oldPassword" :rules="[{required: true, message: '请填写原密码'}]">
                                <el-input type="password" placeholder="请填写原密码" v-model="model.oldPassword" ></el-input>
                            </el-form-item>
                            <el-form-item label="新密码：" prop="newPassword"
                            :rules="[{required: true, message: '请填写新密码'},{max: 13, min: 6, message: '密码长度必须大于5位且小于14位'}]">
                                <el-input type="password" placeholder="请填写新密码" v-model="model.newPassword" ></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码：" prop="repeatPassword" :rules="[{required: true, message: '请再次确认密码'}, {validator: validateRepeatPassword}]">
                                <el-input type="password" placeholder="请再次确认密码" v-model="model.repeatPassword"  redonly></el-input>
                            </el-form-item>
                            <el-form-item >
                                <el-button type="primary" @click="submit" :loading="loading">确认</el-button>
                            </el-form-item>
                        </template>
                    </el-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import {mapState, Store} from 'vuex'
export default {
    data () {
        return {
            loading: false,
            model: {
                oldPassword: '',
                newPassword: '',
                repeatPassword: '',
                username:'',
                id:''
            }
        }
    },
    computed: {
      ...mapState({
        user: state => state.app.user
      })
    },
    methods: {
        validateRepeatPassword (rule, value, cb) {
            if (this.model.repeatPassword && this.model.newPassword && this.model.repeatPassword !== this.model.newPassword) {
                cb(new Error('两次输入的密码必须一致'))
            } else {
                cb()
            }
        },
        submit () {
          this.$refs.form.validate(v => {
            if (v) {
              this.update()
                }
            })
        },
        update () {
          this.model.username = this.user.accountName;
          this.model.id = this.user.id;
            if (this.loading) return
            this.loading = true
            this.$api('app/modifyPassword', this.model).then(() => {
                this.$tips('修改密码成功，请重新登录')
                setTimeout(() => {
                    this.logout()
                }, 1200)
            }).catch(err => {
                this.$tips(err, 'error')
                this.loading = false
            })
        },
        logout () {
            this.$store.dispatch('logout', {router: this.$router})
        }
    }
}
</script>

<style lang="less" scoped>
.modify-password {
    display: flex;
    &-left {
        flex: 1;
        max-width: 1200px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/main/components/user/modify-password.vue